module.exports = __webpack_public_path__ + "static/media/deviant.1cf48cb0.svg";